//including fontAwesome
//In the new version we will import just the necessary icons
//The imported icon should begin with fa, then remove dashes (-) and use camelCase notation
//Example:
//if you want to include this icon "hand-peace", you will write "faHandPeace"

//import fontawesome from "@fortawesome/fontawesome"


//import {
//    faFacebookF,
//    faTwitter,
//    faYoutube,
//    faLinkedinIn,
//    faPinterest,
//    faGooglePlusG,
//    faInstagram,
//    faFacebookSquare,
//    faTwitterSquare,
//    faYoutubeSquare,
//    faLinkedin,
//    faPinterestSquare,
//    faGooglePlusSquare,
//} from "@fortawesome/fontawesome-free-brands"

//import { 
//    faSearch, 
//    faSignInAlt, 
//    faComment, 
//    faBars, 
//    faPhone, 
//    faCaretRight,
//    faLock,
//    faPencilAlt,
//    faQuestionCircle,
//    faExternalLinkAlt,
//    faChevronCircleUp,
//    faChevronCircleRight,
//    faChevronCircleDown,
//    faChevronCircleLeft,
//    faMapMarkerAlt,
//    faStar,
//    faStarHalf,
//    faClock,
//    faDollarSign,
//} from "@fortawesome/fontawesome-free-solid"

//import {
//    faRss,
//    faAngleUp,
//} from "@fortawesome/fontawesome-pro-solid"

//import { 
//    faCalendarAlt,
//    faEnvelope,
//    faCheckSquare,
//    faCalculator,
//} from "@fortawesome/fontawesome-pro-regular"

//import { 
//    faCircle, 
//    faEllipsisH, 
//    faAngleDoubleRight,
//    fapaperplane,
//    faexternallink,
//} from "@fortawesome/fontawesome-pro-light"

//fontawesome.library.add(
//    faCalculator,
//    faCalendarAlt,
//    faEnvelope,
//    faAngleDoubleRight,
//    faAngleUp,
//    faCircle,
//    faEllipsisH,
//    faFacebookF,
//    faTwitter,
//    faYoutube,
//    faLinkedinIn,
//    faPinterest,
//    faGooglePlusG,
//    faInstagram,
//    faRss,
//    faFacebookSquare,
//    faTwitterSquare,
//    faYoutubeSquare,
//    faLinkedin,
//    faPinterestSquare,
//    faGooglePlusSquare,
//    faComment,
//    faSignInAlt,
//    faSearch,
//    faBars,
//    faPhone,
//    faCaretRight,
//    faCheckSquare,
//    faLock,
//    faPencilAlt,
//    faQuestionCircle,
//    faExternalLinkAlt,
//    faChevronCircleUp,
//    faChevronCircleRight,
//    faChevronCircleDown,
//    faChevronCircleLeft,
//    faMapMarkerAlt,
//    faStar,
//    faStarHalf,
//    faClock,
//    faDollarSign,
//    fapaperplane,
//    faexternallink,
//);

// import 'bootstrap/dist/js/bootstrap'
import 'bootstrap'

// include through webpack.ProvidePlugin with exports-loader
import 'bootstrap/js/dist/util'

import Popper from 'popper.js'
/* import Tooltip from 'bootstrap/js/dist/tooltip' */
// import Popover from 'bootstrap/js/dist/popover'

import 'bootstrap/scss/bootstrap.scss'

/* import validation plugin */
import validator from 'jquery-validation/dist/jquery.validate.min.js'

/* importing Fancybox */
import fancybox from '@fancyapps/fancybox'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'

/* importing Swiper Slider */
import Swiper from 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'

/* importing YouTube RYPP plugin */
import rypp from './rypp/js/RYPP.js'
require('./rypp/css/RYPP.scss');

/* Importing style */
require('../style/general.scss');
require('../style/_custom.css');

$(document).ready(function () {


    /* Triguer all tooltips with this event -------------------------- */
    $('[data-toggle="tooltip"]').tooltip();
    /* --------------------------------------------------------------- */


    //FancyBox Example
    $("a.grouped_elements").fancybox({
        'transitionIn': 'elastic',
        'transitionOut': 'elastic',
        'speedIn': 600,
        'speedOut': 100,
        'overlayShow': false
    });


    // Working with Swiper Slider Example
    var swiper = new Swiper('.swiper-container', {
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
        },
    });

    // Transcript Button Text Swap
    jQuery('a.featuredVidTransLink').click(function () { //you can give id or class name here for $('button')
        jQuery(this).text(function (i, old) {
            return old == 'Close Transcript' ? 'View Transcript' : 'Close Transcript';
        });
    });

    jQuery('button.vidTrans').click(function () { //you can give id or class name here for $('button')
        jQuery(this).text(function (i, old) {
            return old == 'Close Transcript' ? 'Read Transcript' : 'Close Transcript';
        });
    });

    setTimeout(
        function () {
            jQuery('a.yotu-pagination-prev').html('&#171; Prev')
            jQuery('a.yotu-pagination-next').html('Next &#187;');
        }, 1255);


}); //End of $(document).ready(...)

//Populate Video Modal functionality
jQuery('#videoModal').on('show.bs.modal', function (event) {
    var a = jQuery(event.relatedTarget) // anchor that triggered the modal
    var dataURL = a.data('link') // Video Link
    var dataTitle = a.data('title') // Video Title
    var dataDate = a.data('date') // Video Title
    var dataTime = a.data('time') // Video Title
    var dataTrans = a.data('trans') // Video Transscript
    //Check if 'DATA-TRANSCRIPT' has value, hide button if not
    if ((dataTrans === null) || (dataTrans === '')) {
        jQuery('.readTranscript').addClass('d-none');
    }
    else {
        jQuery('.readTranscript').removeClass('d-none');
    }
    //var dataContent = a.data('content') // TEST CONTENT
    var modal = jQuery(this)
    //modal.find('.modal-body p#modalContent').text(dataContent)
    modal.find('#vidModIframe').attr('src', dataURL)
    modal.find('.vidTitle').text(dataTitle)
    modal.find('.vidDate').text(dataDate)
    modal.find('.vidTime').text(dataTime)
    modal.find('.vidTranscript').html(dataTrans)
});

jQuery('#videoModal').on('hide.bs.modal', function (event) {
    var a = jQuery(event.relatedTarget) // anchor that triggered the modal
    var dataURL = a.data('link') // Video Link
    var dataTitle = a.data('title') // Video Title
    var dataDate = a.data('date') // Video Title
    var dataTime = a.data('time') // Video Title
    var dataTrans = a.data('trans') // Video Transscript
    //var dataContent = a.data('content') // TEST CONTENT
    var modal = jQuery(this)
    //modal.find('.modal-body p#modalContent').text(dataContent)
    modal.find('#vidModIframe').attr('src', '')
    modal.find('.vidTitle').text('')
    modal.find('.vidDate').text('')
    modal.find('.vidTime').text('')
    modal.find('.vidTranscript').text('')
});

//Ask Howard Form, Label Switch (TO FIX WAVE ERROR)
jQuery(document).ready(function () {
    function swapLabel() {
        jQuery("label[for='nf-field-hp-2']").text("no contrast errors in form");
    }
    setTimeout(swapLabel, 500)
});


// WEBPACK FOOTER //
// ./src/js/main.js